"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HidePoppersEvent = void 0;
const _1 = require(".");
const FoquzEvent = (0, _1.Event)();
const HidePoppersEvent = FoquzEvent.get('poppers.hide');
exports.HidePoppersEvent = HidePoppersEvent;
